import { LegalLayout, Section, Li, B } from "../components/LegalLayout";

const UPDATED = "June 1, 2026";

export default function CookiesPolicy() {
  return (
    <LegalLayout title="Cookie Policy" updated={UPDATED}>
      <p className="text-slate-300">
        This Cookie Policy explains how PNR Decode uses cookies and similar technologies to recognise you when you
        visit our website, and the choices you have to control them.
      </p>

      <Section heading="1. What Are Cookies?">
        <p>
          Cookies are small text files placed on your device when you visit a website. They help the site remember
          your actions and preferences (such as login sessions) over time. We also use similar technologies like
          local storage and pixels, which we refer to collectively as "cookies".
        </p>
      </Section>

      <Section heading="2. Types of Cookies We Use">
        <ul className="space-y-2">
          <Li><b>Essential cookies:</b> required for the site to function — for example, keeping you signed in
            (we store your authentication token), securing forms, and remembering your theme. The site cannot work
            properly without these.</Li>
          <Li><b>Analytics cookies:</b> help us understand how visitors use the site (pages viewed, features used)
            so we can improve performance and usability. These are aggregated and non-identifying.</Li>
          <Li><b>Marketing cookies:</b> used to measure the effectiveness of campaigns and, where enabled, to show
            relevant messaging. We only set these with your consent.</Li>
        </ul>
      </Section>

      <Section heading="3. How to Manage or Disable Cookies">
        <ul className="space-y-2">
          <Li>Most browsers let you view, block or delete cookies through their settings menu.</Li>
          <Li>You can clear local storage (which removes your saved login) from your browser's site-data controls.</Li>
          <Li>Disabling essential cookies may prevent you from logging in or using core features.</Li>
          <Li>Where required, we present a consent banner so you can accept or reject non-essential cookies.</Li>
        </ul>
      </Section>

      <Section heading="4. Third-Party Cookies">
        <p>
          Some cookies may be set by trusted third parties that provide services on our behalf, such as analytics or
          payment processing. Their use of cookies is governed by their own privacy and cookie policies.
        </p>
      </Section>

      <Section heading="5. Contact">
        <p>For any cookie-related queries, email us at <B>support@pnrdecode.com</B>.</p>
      </Section>
    </LegalLayout>
  );
}
